import styled from 'styled-components';

export const Items = styled.div`
	width: 100%;
	height: calc(100vh - 7rem);
	position: relative;
	overflow-x: hidden;
	overflow-y: auto;
	padding: 6rem 2rem 2rem;
	scroll-behavior: smooth;
`;
